import mapErrosSefaz from './tabelas/mapErrosSefaz'

/**
 * Número de nota não autorizada que foi descartado sem pedido de inutilização: AC, BA e SP a partir de 01/11/2026
 * (Ajustes SINIEF 38 e 40/2026), ou SEFAZ que desligou o serviço (998). A nota fica com cStat 102, o mesmo da
 * inutilização homologada, e só a marcação vinda do servidor separa um caso do outro.
 */
export const DESCRICAO_DO_NUMERO_DESCARTADO = 'Número descartado (inutilização dispensada)'

/** Texto do status da SEFAZ, com o 102 do número descartado separado do 102 da inutilização homologada. */
export function descricaoDoStatusSefaz(cstat?: string | null, inutilizacaoDispensada?: boolean | null): string | undefined {
	if (cstat === '102' && inutilizacaoDispensada) return DESCRICAO_DO_NUMERO_DESCARTADO
	return cstat ? mapErrosSefaz[cstat] : undefined
}
